import React from "react";
import { regulators } from "../../data/home";
export function TrustStrip() {
  return <section className="border-y border-line px-5 py-10 md:px-8" aria-label="Agréments et contrôles" data-id="element-201" data-mp="3l6cwvsff3bas">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 lg:flex-row lg:justify-between" data-id="element-202" data-mp="3h4rdrpcai0s5">
        <p className="max-w-xs text-center text-[15px] text-muted lg:text-left" data-id="element-203" data-mp="3c6y8cyit9asx">
          Cabinet agréé CIF et courtier en assurance, contrôlé par les autorités françaises.
        </p>
        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4" data-id="element-204" data-mp="8ppok94iw0vk">
          {regulators.map(name => <li key={name} className="whitespace-nowrap text-lg font-semibold tracking-tight text-ink/45" data-id="element-205" data-mp="3xpnuegmp3xx">
              {name}
            </li>)}
        </ul>
      </div>
    </section>;
}